export default __webpack_public_path__ + "static/media/DIN-Medium.ac50005d.ttf";